<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.project_name"
                  :clearable="true"
                  placeholder="请输入项目名称"
                  size="small"
                  style="width: 180px"
                ></el-input>
                <el-select
                  :clearable="true"
                  size="small"
                  v-model="search.cat_id"
                  placeholder="请选择项目分类"
                  style="width: 180px"
                >
                  <el-option
                    v-for="item in projectType"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs.tables.handleSearch()"
                >搜索</el-button>
              </el-card>

              <WtDataTable ref="tables" :search="search" :listUrl="$db.config.publicComProjectList">
                <div slot="buttons"></div>
                <template slot="columns">
                  <el-table-column prop="project_code" label="项目编号" align="center" min-width="120"></el-table-column>
                  <el-table-column label="项目名称" prop="project_name" align="center" min-width="150">
                    <template slot-scope="scope">
                      <router-link
                        :to="'/hospitalComProjectInfo?id='+scope.row.id"
                      >{{scope.row.project_name}}</router-link>
                      <div style="color:#666">{{scope.row.regdate_start}}至{{scope.row.regdate_end}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="立项类型" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{scope.row.project_before_type_text}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="媒体报告次数" min-width="60" align="center">
                    <template slot-scope="scope">
                      <a
                        href="javascript:;"
                        @click="toMediaList(scope.row.id)"
                      >{{scope.row.media_count}}</a>
                      <!-- <router-link
                        :to="'/hospitalProjectMediaList?project_id='+scope.row.id"
                      >{{scope.row.media_count}}</router-link>-->
                    </template>
                  </el-table-column>
                  <el-table-column label="阶段报告次数" min-width="60" align="center">
                    <template slot-scope="scope">
                      <a
                        href="javascript:;"
                        @click="toReportList(scope.row.id)"
                      >{{scope.row.report_count}}</a>
                      <!-- <router-link
                        :to="'/hospitalProjectReportList?id='+scope.row.id+'&addabled=1'"
                        v-if="scope.row.ifreport==1"
                      >{{scope.row.report_count}}</router-link>
                      <router-link
                        :to="'/hospitalProjectReportList?id='+scope.row.id+'&addabled=2'"
                        v-else
                      >{{scope.row.report_count}}</router-link>-->
                    </template>
                  </el-table-column>
                  <el-table-column prop="status_text" label="状态" min-width="150" align="center">
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.province_audit_status == 2 && scope.row.if_province == 1"
                        style="color:red;text-decoration: underline; cursor: pointer;"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.province_audit_opinion"
                        >
                          <span slot="reference">{{scope.row.status_text}}</span>
                        </el-popover>
                      </span>

                      <span
                        v-else-if="scope.row.node_id > 0 && scope.row.node_status == 2 && scope.row.status == 3"
                        style="color:red;text-decoration: underline; cursor: pointer;"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.audit_opinion"
                        >
                          <span slot="reference">{{scope.row.status_text}}</span>
                        </el-popover>
                      </span>

                      <span v-else>{{scope.row.status_text}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" min-width="320" fixed="right">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="info"
                          icon="el-icon-edit"
                          size="mini"
                          @click="showMedia(scope.row)"
                        >媒体报道</el-button>
                        <el-button
                          type="danger"
                          icon="el-icon-success"
                          size="mini"
                          v-if="!scope.row.node_id && scope.row.node_is_edit == 2"
                          @click="showEndModal(scope.row)"
                        >提交结项</el-button>

                        <el-button
                          type="danger"
                          icon="el-icon-success"
                          size="mini"
                          v-if="(scope.row.node_id > 0) && scope.row.node_is_edit == 1"
                          @click="showEndModal(scope.row)"
                        >修改结项</el-button>

                        <el-button
                          type="primary"
                          icon="el-icon-tickets"
                          size="mini"
                          @click="addReport(scope.row)"
                        >提交报告</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>

              <media
                v-if="if_open1"
                v-model="if_open1"
                :title="media_title"
                :id="project_id"
                @success="success"
                :type="1"
              ></media>

              <end-report
                v-if="if_open2"
                v-model="if_open2"
                :title="end_title"
                :id="node_id"
                :pid="project_id"
                @success="success"
              ></end-report>

              <report
                v-if="if_open3"
                v-model="if_open3"
                :title="report_title"
                :aid="approval_id"
                :pid="project_id"
                @success="success"
              ></report>
            </div>
          </el-col>
        </el-row>
      </div>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import "../../public/poster.less";
import baseUrl from "@/config/index";
import Axios from "axios";
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import media from "../../cfproject/info/media";
import endReport from "./end";
import report from "./report";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    media,
    endReport,
    report
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      uploadParms: { file_type: 2 }, //图片上传所需参数

      search: {},

      if_open1: false, //媒体报道
      media_title: null,
      project_id: null,

      if_open2: false, //结项报告
      node_id: null, //用来判断修改结项报告
      end_title: null, //

      if_open3: false, //阶段性报告
      approval_id: null, //立项id
      report_title: null,

      projectType: [],

      endInfoForm: {
        apply_user_name: null,
        file_id: null,
        node_time: null,
        reasons: null
      }, //结项提交数据
      uploadFileUrl: "", //上传链接
      defFile: [], //编辑默认文件
      abstract: {}, //结项资料的项目摘要
      rules: {
        apply_user_name: [
          { required: true, message: "请输入公益事务代表！", trigger: "blur" }
        ],
        node_time: [
          { required: true, message: "请选择结项时间！", trigger: "change" }
        ],
        reasons: [
          { required: true, message: "请填写结项原因！", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    //跳转媒体报道列表
    toMediaList(id) {
      this.$router.push({
        path: "/hospitalProjectMediaList",
        query: { project_id: id }
      });
    },

    //跳转报告列表
    toReportList(id) {
      this.$router.push({
        path: "/hospitalProjectReportList",
        query: { id: id }
      });
    },

    //媒体报道
    showMedia(row) {
      this.project_id = row.id;
      this.media_title = row.project_name;
      this.if_open1 = true;
    },

    addReport(row) {
      this.approval_id = row.approval_id;
      this.project_id = row.id;
      this.report_title = row.project_name;
      this.if_open3 = true;
    },

    //提交结项资料
    showEndModal(row) {
      if (row.node_id > 0) {
        //修改结项
        this.node_id = row.node_id;
      } else {
        this.node_id = null;
      }
      this.project_id = row.id;
      this.end_title = row.project_name;
      this.if_open2 = true;
    },

    success() {
      this.$refs.tables.reloadData();
    }
  },
  mounted() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    //获取项目分类接口

    this.$db
      .post(this.$db.config.getDictParam, {
        pid: 100180,
        table: "pub_type_param"
      })
      .then(res => {
        if (res && res.code == 200) {
          this.projectType = res.data;
        }
      });
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .edit_container /deep/ .ql-editor {
    min-height: 200px !important;
  }
  .span_box i {
    text-decoration: underline;
    font-style: normal;
    margin-left: 2px;
    margin-right: 2px;
    font-size: 16px;
    color: #333;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/info/list.vue